import { OsIconName } from '@shared/ui';

export type TSiteToolId = 'cronograma' | 'mensagem' | 'rdo' | 'checklist';

export interface ISiteTool {
	id: TSiteToolId;
	path: string;
	title: string;
	text: string;
	icon: OsIconName;
}

/** Ferramentas grátis, sem cadastro (`/tools`). A ordem é a da página. */
export const SITE_TOOLS: ISiteTool[] = [
	{
		id: 'cronograma',
		path: '/tools/renovation-schedule',
		title: 'Gerador de cronograma de reforma',
		text: 'Escolha o tipo de obra e as datas. As etapas saem divididas no prazo, prontas para imprimir.',
		icon: 'gantt',
	},
	{
		id: 'mensagem',
		path: '/tools/client-message',
		title: 'Mensagem da semana para o cliente',
		text: 'Conte o que aconteceu na obra e mande ao cliente um resumo organizado pelo WhatsApp.',
		icon: 'whatsapp',
	},
	{
		id: 'rdo',
		path: '/tools/daily-report-template',
		title: 'Modelo de diário de obra (RDO)',
		text: 'Uma folha de diário de obra para imprimir ou salvar em PDF, já com os dados da obra.',
		icon: 'arquivo',
	},
	{
		id: 'checklist',
		path: '/tools/handover-checklist',
		title: 'Checklist de vistoria e entrega',
		text: 'O que conferir antes de entregar a obra ao cliente: paredes, pisos, elétrica, hidráulica e documentos.',
		icon: 'check',
	},
];

export interface IChecklistGroup {
	title: string;
	items: string[];
}

/** Vistoria de entrega: o que costuma voltar como reclamação depois da mudança. */
export const DELIVERY_CHECKLIST: IChecklistGroup[] = [
	{
		title: 'Antes de começar',
		items: [
			'Obra limpa, sem entulho e sem material sobrando',
			'Luz em todos os cômodos para enxergar os detalhes',
			'Chaves, controles e manuais separados para entregar',
		],
	},
	{
		title: 'Paredes, tetos e pintura',
		items: [
			'Pintura uniforme, sem manchas, escorridos ou marcas de rolo',
			'Sem trincas, fissuras ou bolhas',
			'Cantos e arestas retos',
			'Rodapés firmes e com o acabamento completo',
		],
	},
	{
		title: 'Pisos e revestimentos',
		items: [
			'Sem peças trincadas, lascadas ou soando oco (bata de leve)',
			'Rejunte completo, uniforme e limpo',
			'Água corre para o ralo nas áreas molhadas (jogue um balde)',
			'Soleiras e peitoris firmes',
		],
	},
	{
		title: 'Portas e janelas',
		items: [
			'Abrem e fecham sem raspar nem emperrar',
			'Fechaduras, chaves e trincos funcionando',
			'Vidros sem riscos nem trincas',
			'Sem frestas nem entrada de água',
		],
	},
	{
		title: 'Elétrica',
		items: [
			'Todas as tomadas com energia (teste com um carregador)',
			'Cada interruptor acende a luz certa',
			'Quadro de luz com os circuitos identificados',
			'Espelhos de tomadas e interruptores alinhados e firmes',
		],
	},
	{
		title: 'Hidráulica',
		items: [
			'Torneiras e registros sem vazamento',
			'Descargas funcionando, sem água escorrendo no vaso',
			'Ralos e sifões escoando bem',
			'Água quente chegando onde foi prevista',
			'Sem umidade embaixo de pias e bancadas',
		],
	},
	{
		title: 'Louças, metais e bancadas',
		items: [
			'Louças firmes e com o acabamento de silicone',
			'Metais sem riscos e bem fixados',
			'Bancadas niveladas, sem manchas e com as bordas acabadas',
		],
	},
	{
		title: 'Marcenaria',
		items: [
			'Portas e gavetas alinhadas, abrindo sem esforço',
			'Puxadores e dobradiças regulados',
			'Sem lascas, riscos ou marcas no acabamento',
		],
	},
	{
		title: 'Documentos',
		items: [
			'Projeto final, com o que mudou durante a obra',
			'Manuais e garantias dos equipamentos',
			'Notas fiscais dos materiais com garantia',
			'Termo de entrega assinado pelo cliente',
		],
	},
];

/** Linhas em branco de cada bloco da folha de RDO. */
export const RDO_BLOCKS: { title: string; lines: number }[] = [
	{ title: 'Serviços executados', lines: 5 },
	{ title: 'Materiais recebidos', lines: 2 },
	{ title: 'Ocorrências e problemas', lines: 3 },
	{ title: 'Visitas (cliente, fornecedores, fiscalização)', lines: 2 },
];
